<template>
  <div class="login-form-wrapper">
    <div class="div-block-20">
      <div class="div-block login">
        <div class="text-block">Change password</div>
        <div class="text-block-3">Create a new password for your account</div>
      </div>
      <div class="div-block">
        <FormulateForm>
          <img
            v-if="type === 'password'"
            @click="togglePassword"
            style="cursor: pointer;"
            src="@/assets/timeslot-images/visual.png"
            class="password-eye"
          />
          <img
            @click="togglePassword"
            style="cursor: pointer;"
            v-else
            src="@/assets/timeslot-images/eye.png"
            class="password-eye"
          />
          <FormulateInput
            type="password"
            placeholder="Set password"
            validation="required"
            validation-name="Password"
          />
          <img
            v-if="typeConfirm === 'password'"
            src="@/assets/timeslot-images/visual.png"
            class="password-eye"
            @click="toggleConfirmPassword"
            style="cursor: pointer;"
          />
          <img
            v-else
            src="@/assets/timeslot-images/eye.png"
            class="password-eye"
            @click="toggleConfirmPassword"
            style="cursor: pointer;"
          />
          <FormulateInput
            type="password"
            validation="required|confirm"
            placeholder="Confirm password"
            validation-name="Password Confirmation"
          />
          <FormulateInput
            type="submit"
            label="Change password"
            @click="success"
          />
        </FormulateForm>
      </div>
    </div>
    <div class="text-block-2">© {{ currentYear() }} Timeslate</div>
  </div>
</template>

<script>
import RouterUtils from "@/utils/BaseUtils/RouterUtils";

export default {
  name: "TimeSlotChangePasswordForm",
  data() {
    return {
      password: "",
      passwordConfirm: "",
      type: "password",
      typeConfirm: "password",
      image: "visual"
    };
  },
  methods: {
    success() {
      RouterUtils.changeRouteTo(RouterUtils.routes.auth.RESET_SUCCESS);
    },
    currentYear() {
      let current_date = new Date();
      let current_year = current_date.getFullYear();
      return current_year;
    },
    togglePassword() {
      if (this.type === "password") {
        this.type = "text";
        this.image = "eye";
      } else {
        this.type = "password";
        this.image = "visual";
      }
    },
    toggleConfirmPassword() {
      if (this.typeConfirm === "password") {
        this.typeConfirm = "text";
        this.image = "eye";
      } else {
        this.typeConfirm = "password";
        this.image = "visual";
      }
    }
  }
};
</script>

<style scoped>
.password-eye {
  position: relative;
  top: 38px;
  left: 43%;
  width: 20px;
  height: 20px;
  opacity: 0.7;
}
</style>
